(() => {
  const dynamicCanvas = document.getElementById('easter-dynamic-canvas');
  const dynamicCtx = dynamicCanvas.getContext('2d');

  const dpr = 3;
  dynamicCanvas.width = window.innerWidth * dpr;
  dynamicCanvas.height = 60 * dpr;
  dynamicCanvas.style.width = window.innerWidth + 'px';
  dynamicCanvas.style.height = '60px';
  dynamicCtx.scale(dpr, dpr);

  const images = {};
  const loadImages = (urls) => {
    return Promise.all(urls.map(url => new Promise(resolve => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(img);
    })));
  };

  const assetUrls = {
    rabbit: "//woodandhearts.com/cdn/shop/t/193/assets/easter-rabbit_1000x.svg?v=54919322041241670581745328138",
    eggs: [
      "//woodandhearts.com/cdn/shop/t/193/assets/easter-egg1_1000x.svg?v=173068615831024107831745328135",
      "//woodandhearts.com/cdn/shop/t/193/assets/easter-egg2_1000x.svg?v=165396223828880078161745328136",
      "//woodandhearts.com/cdn/shop/t/193/assets/easter-egg3_1000x.svg?v=142365384585664124001745328136",
      "//woodandhearts.com/cdn/shop/t/193/assets/easter-egg4_1000x.svg?v=130355737710449916251745328136"
    ],
  };

  const eggs = [];
  const rabbit = { x: 20, y: 10, vy: 0, jumping: false };
  let basketPos = dynamicCanvas.width;

  class Egg {
    constructor() {
      this.x = 50;
      this.y = 30;
      this.vx = 2;
      this.vy = -3;
      this.gravity = 0.1;
      this.rotation = 0;
      this.rotationSpeed = 0.05;
      this.throwing = true;
      this.inBasket = false;
      this.image = images.eggs[Math.floor(Math.random() * images.eggs.length)];
    }
    update() {
      if (this.throwing) {
        this.x += this.vx;
        this.y += this.vy;
        this.vy += this.gravity;
        if (this.y >= 30) {
          this.throwing = false;
          this.y = 30;
        }
      } else {
        this.x += this.vx;
        this.rotation += this.rotationSpeed;
      }
      if (this.x >= basketPos - 50 && !this.inBasket) {
        this.inBasket = true;
        this.vx = 1;
        this.vy = -3;
        this.gravity = 0.15;
        setTimeout(() => eggs.shift(), 500);
      }
      if (this.inBasket) {
        this.x += this.vx;
        this.y += this.vy;
        this.vy += this.gravity;
      }
    }
    draw() {
      dynamicCtx.save();
      dynamicCtx.translate(this.x + 15, this.y + 15);
      dynamicCtx.rotate(this.rotation);
      dynamicCtx.drawImage(this.image, -15, -15, 30, 30);
      dynamicCtx.restore();
    }
  }

  function spawnEgg() {
    if (eggs.length < 4) {
      eggs.push(new Egg());
      rabbit.jumping = true;
      rabbit.vy = 5;
    }
  }

  function animate() {
    dynamicCtx.clearRect(0, 0, dynamicCanvas.width, dynamicCanvas.height);

    if (rabbit.jumping) {
      rabbit.y -= rabbit.vy;
      rabbit.vy -= 0.3;
      if (rabbit.y >= 10) {
        rabbit.y = 10;
        rabbit.jumping = false;
      }
    }

    dynamicCtx.save();
    dynamicCtx.scale(-1, 1);
    dynamicCtx.drawImage(images.rabbit, -rabbit.x - 40, rabbit.y, 30, 50);
    dynamicCtx.restore();

    eggs.forEach(egg => {
      egg.update();
      egg.draw();
    });

    requestAnimationFrame(animate);
  }

  function resizeCanvas() {
    dynamicCanvas.width = window.innerWidth * dpr;
    dynamicCanvas.height = 60 * dpr;
    dynamicCanvas.style.width = window.innerWidth + 'px';
    dynamicCanvas.style.height = '60px';
    dynamicCtx.setTransform(1, 0, 0, 1, 0, 0);
    dynamicCtx.scale(dpr, dpr);

    basketPos = window.innerWidth - 60;
  }

  window.addEventListener('resize', resizeCanvas);

  loadImages([assetUrls.rabbit, ...assetUrls.eggs]).then(loadedImages => {
    images.rabbit = loadedImages[0];
    images.eggs = loadedImages.slice(1, assetUrls.eggs.length + 1);
    resizeCanvas();
    setInterval(spawnEgg, 3000);
    animate();
  });
})();
